module.exports = __webpack_public_path__ + "static/img/fordeal.3417781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/fordeal.png
// module id = L0vQ
// module chunks = 9